import { lazy, Suspense, type ReactElement } from "react";
import { Navigate, RouterProvider, createBrowserRouter, useSearchParams } from "react-router-dom";
import { normalizeStoreCode } from "./domain/config";
import { HomePage } from "./pages/HomePage";
import { NotFoundPage } from "./pages/NotFoundPage";

const StoreDashboardPage = lazy(() => import("./pages/StoreDashboardPage").then((module) => ({ default: module.StoreDashboardPage })));
const FryerPage = lazy(() => import("./pages/FryerPage").then((module) => ({ default: module.FryerPage })));
const LeadershipPage = lazy(() => import("./pages/LeadershipPage").then((module) => ({ default: module.LeadershipPage })));
const DevelopmentPage = lazy(() => import("./pages/DevelopmentPage").then((module) => ({ default: module.DevelopmentPage })));
const DevelopmentStorePage = lazy(() => import("./pages/DevelopmentPage").then((module) => ({ default: module.DevelopmentStorePage })));

function deferred(element: ReactElement) {
  return <Suspense fallback={<div className="route-loading">Loading OpsTrack…</div>}>{element}</Suspense>;
}

function LegacyStoreRedirect() {
  const [search] = useSearchParams();
  return <Navigate replace to={`/store/${encodeURIComponent(normalizeStoreCode(search.get("store")))}`} />;
}

function LegacyFryerRedirect() {
  const [search] = useSearchParams();
  const storeCode = normalizeStoreCode(search.get("store"));
  const fryerId = search.get("id") || "1";
  return <Navigate replace to={`/fryer/${encodeURIComponent(storeCode)}/${encodeURIComponent(fryerId)}`} />;
}

function LegacyLeadershipRedirect() {
  const [search] = useSearchParams();
  return <Navigate replace to={`/leadership/${encodeURIComponent(normalizeStoreCode(search.get("store")))}`} />;
}

const router = createBrowserRouter([
  { path: "/", element: <HomePage /> },
  { path: "/store/:storeCode", element: deferred(<StoreDashboardPage />) },
  { path: "/fryer/:storeCode/:fryerId", element: deferred(<FryerPage />) },
  { path: "/leadership/:storeCode", element: deferred(<LeadershipPage />) },
  { path: "/development", element: deferred(<DevelopmentPage />) },
  { path: "/development/:storeCode", element: deferred(<DevelopmentStorePage />) },
  { path: "/index.html", element: <LegacyStoreRedirect /> },
  { path: "/fryer", element: <LegacyFryerRedirect /> },
  { path: "/fryer.html", element: <LegacyFryerRedirect /> },
  { path: "/leadership-dashboard.html", element: <LegacyLeadershipRedirect /> },
  { path: "/development-dashboard.html", element: <Navigate replace to="/development" /> },
  { path: "*", element: <NotFoundPage /> }
]);

export function App() {
  return <RouterProvider router={router} />;
}
